export const qrStyles = {
  qrContainer: {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // textAlign: "center",
  },
  qrBox: {
    marginVertical: "20px",
    width: "270px",
    height: "270px",
    backgroundColor: "white",
    boxShadow: "0px 4px 18px 4px rgba(0, 0, 0, 0.14)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "10px",
  },
};
